import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@14.2.29_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.61.1_react-dom@18_ssmh7ke62zmbpyrtkp54xgx7m4/node_modules/next/dist/client/link.js");
